'use strict'
const stickyEl = {
	el: {
		elem: document.querySelectorAll('.js-sticky'),
		trigger: document.querySelector('.js-trigger-sticky')
	},

	vars: {
		lastScrollTop: 0
	},

	fxToggleClass (el, triggerElement) {
		const st = window.pageYOffset || document.documentElement.scrollTop
		let direction = null

		if(st > this.vars.lastScrollTop) {
			direction = 'down'
		} else if (st < this.vars.lastScrollTop) {
			direction = 'up'
		}

		this.vars.lastScrollTop = st <= 0 ? 0 : st

		if(window.pageYOffset >= triggerElement.offsetHeight) {
			if(el.dataset.scroll === 'true') {
				direction === 'up' ? el.classList.add('sticky') : el.classList.remove('sticky')
			} else {
				el.classList.add('sticky')
			}
		} else {
			el.classList.remove('sticky')
		}
	},

	events() {
		if(!this.el.trigger) return
		window.onscroll = () => {
			for (const stickyEl of this.el.elem) {
				this.fxToggleClass(stickyEl, this.el.trigger)
			}
			const counterEl = document.querySelector('.counter')
			if(counterEl)
				counter.fxStartCounter(counterEl)
		}
	},

	init () {
		this.events()
	}
}

stickyEl.init()